// @flow

import React from 'react';
import styled, { css } from 'styled-components';

const IconWrapper = styled.span`
  position: relative;
  top: 3px;

  ${props => props.withMargin && css`
    margin-right: 0.4em;
  `}

  ${props => props.size && css`
    font-size: ${props.size}px;
  `}
`;

type Props = {
  size?: number,
  type: string,
  withMargin?: boolean
}

const Icon = (props: Props) => {
  return (
    <IconWrapper className={`ss-icon ss-${props.type}`} {...props}></IconWrapper>
  );
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon.js